import {
	Container,
	ContainerGutter,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { huchaLinesColor } from '../../../../../../../../helpers/color-tokens';
import { useIsLandscape } from '../../../../../../../../hooks/use-is-landscape';
import { Super100ResponsiveText, Super100SymbolResponsiveText } from '../../../ui/money-font-styles';
import { HuchaRenovadoresLabel } from '../../../ui/hucha-renovadores-label';

const MainContainer = styled(Container)<{ $landscape: boolean }>`
	overflow: visible;
	padding: 0px;
	align-content: center;

	/* Mobile */
	@media (max-width: 959px) {
		padding-top: 40px;
	}

	/* Tablet */
	@media (min-width: 960px) and (max-width: 1279px) {
		padding-top: ${({ $landscape }) => ($landscape ? '18px' : '40px')};
	}

	/* Desktop */
	@media (min-width: 1280px) {
		padding-top: 18px;
	}
`;

const StyledC3Wrapper = styled.div<{ $landscape: boolean }>`
	border: 2px solid ${huchaLinesColor};
	border-radius: 16px;
	position: relative;
	align-content: center;

	/* Mobile */
	@media (max-width: 959px) {
		height: 280px;
	}

	/* Tablet */
	@media (min-width: 960px) and (max-width: 1279px) {
		height: ${({ $landscape }) => ($landscape ? '270px' : '280px')};
	}

	/* Desktop */
	@media (min-width: 1280px) {
		height: 270px;
	}
`;

const StyledTextWrapper = styled(Container)`
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	padding-top: var(--size-dynamic0050);
	padding-bottom: var(--size-dynamic0050);
	padding-left: 4px;
	padding-right: 4px;
	width: 292px;

	/* Aseguramos que el wrapper se centre horizontalmente cuando el padre hace wrap='always' */
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 559px) {
		max-width: 227px;
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;

	/* Mobile */
	@media (max-width: 559px) {
		margin-top: 0px;
	}
`;

export const PopupHuchaRenovadoresCardC3 = () => {
	const badge = '2'; // badge siempre es "2" respecto al popup/pdf
	const isLandscape = useIsLandscape();

	return (
		<MainContainer $landscape={isLandscape} stretchContent data-testid="c3-container">
			<StyledC3Wrapper $landscape={isLandscape}>
				<HuchaRenovadoresLabel />
				<Container
					gutter={ContainerGutter.dynamic0100}
					verticalAlign="center"
					stretchContent
					horizontalAlign="center"
					data-testid="c3-inner-container"
					wrap="always"
				>
					<Container wrap="never" horizontalAlign="center">
						<Container wrap="never" verticalAlign="flex-end">
							<Super100ResponsiveText color={TokenTextColor.inverted}>+1.000</Super100ResponsiveText>
							<Super100SymbolResponsiveText color={TokenTextColor.inverted}>{'€'}</Super100SymbolResponsiveText>
						</Container>
						<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
					</Container>

					<StyledTextWrapper stretchContent verticalAlign="center" horizontalAlign="center">
						<Text
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.inverted}
							textAlign={TextAlignment.center}
						>
							{'La Excusa Oficial Volkswagen para renovar tu coche este año'}
						</Text>
					</StyledTextWrapper>
				</Container>
			</StyledC3Wrapper>
		</MainContainer>
	);
};
